if(window.innerWidth < 768) {
  
!function() {
  var e = function(e) {
    var t, n;
    this.element = e, this.list = this.element.getElementsByTagName("ul")[0], this.items = this.list.children, this.paused = !1, this.clones = this.list.innerHTML, this.clonesNumber = 1, this.itemsLength = this.items.length, this.animationDuration = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--ticker-animation-duration")), i(t = this), s(t), n = t, new IntersectionObserver(function(e) {
      e[0].isIntersecting ? this.paused || this.element.classList.add("ticker--animate") : this.element.classList.remove("ticker--animate")
    }.bind(n)).observe(n.element), t.element.addEventListener("update-ticker", function(e) {
      i(t), s(t)
    }), t.element.addEventListener("anim-ticker", function(e) {
      t.paused = !1, t.element.classList.remove("ticker--paused")
    }), t.element.addEventListener("pause-ticker", function(e) {
      t.paused = !0, t.element.classList.add("ticker--paused")
    }), t.element.classList.add("ticker--loaded")
  };

  function i(e) {
    for (var t, n, i = 0, s = 0; s < e.itemsLength; s++) i += (t = e.items[s], void 0, n = window.getComputedStyle(t), parseFloat(n.marginRight) + parseFloat(n.marginLeft) + t.offsetWidth);
    i < window.innerWidth ? e.clonesNumber = 2 * Math.ceil(window.innerWidth / i) - 1 : e.clonesNumber = 1, e.list.style.width = (e.clonesNumber + 1) * i + "px"
  }

  function s(e) {
    e.list.innerHTML = e.clones;
    for (var t = 0; t < e.clonesNumber; t++) e.list.insertAdjacentHTML("beforeend", e.clones);
    e.element.style.setProperty("--ticker-animation-duration", e.animationDuration * (e.clonesNumber + 1) + "s")
  }

  function t(s) {
    var e = document.getElementById(s.getAttribute("aria-controls"));
    if (e) {
      var r = e.getElementsByClassName("js-ticker");
      r.length < 1 && (r = [e]), s.addEventListener("click", function(e) {
        var t = "true" == s.getAttribute("aria-pressed"),
          n = t ? "anim-ticker" : "pause-ticker";
        t ? s.setAttribute("aria-pressed", "false") : s.setAttribute("aria-pressed", "true");
        for (var i = 0; i < r.length; i++) r[i].dispatchEvent(new CustomEvent(n))
      })
    }
  }
  var n, r = document.getElementsByClassName("js-ticker"),
    a = window.requestAnimationFrame,
    o = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    c = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype;
  if (0 < r.length) {
    for (var d = [], l = 0; l < r.length; l++) a && !o && c ? (n = l, d.push(new e(r[n]))) : r[l].classList.add("ticker--anim-off");
    if (0 < d.length) {
      var m = !1,
        u = new CustomEvent("update-ticker");

      function h() {
        for (var e = 0; e < d.length; e++) d[e].element.dispatchEvent(u)
      }
      window.addEventListener("resize", function() {
        clearTimeout(m), m = setTimeout(h, 500)
      }), document.fonts && (document.fonts.onloadingdone = function(e) {
        h()
      });
      var f = document.getElementsByClassName("js-ticker-control");
      if (0 < f.length)
        for (l = 0; l < f.length; l++) a && !o && c ? t(f[l]) : f[l].classList.add("hide")
    }
  }
}();

}